export const firebaseConfig = {
    apiKey: "AIzaSyAP1fDgYh2ZywVPOdQtNh3zFzN7BwxFyQE",
    authDomain: "wast-e-3743e.firebaseapp.com",
    databaseURL: "https://wast-e-3743e.firebaseio.com",
    projectId: "wast-e-3743e",
    storageBucket: "wast-e-3743e.appspot.com",
    messagingSenderId: "491243370427",
    appId: "1:491243370427:web:2ac5fe9f0270c987e2769e",
    measurementId: "G-N8BQBHCL1K"
  };